import { NotificationIcon, useSession } from '@zhiyue/core';
import { hasOAuth2Session } from '@/services/oauth2';
import React from 'react';
import { fetchOpenPlatformToken } from '@/services/openPlatformToken';

const normalizeText = (value: unknown) => String(value ?? '').trim();

const OpenPlatformNotificationIcon: React.FC = () => {
  const { currentUser, loading } = useSession();
  const [token, setToken] = React.useState('');
  const tenantUuid = normalizeText(currentUser?.tenantUuid);
  const organizationUuid = normalizeText(
    (currentUser as (typeof currentUser & { organizationUuid?: string }) | null)
      ?.organizationUuid,
  );
  const memberUuid = normalizeText(currentUser?.memberUuid);

  React.useEffect(() => {
    if (loading || !hasOAuth2Session() || !memberUuid) {
      setToken('');
      return;
    }

    let cancelled = false;
    void fetchOpenPlatformToken({ tenantUuid, organizationUuid, memberUuid })
      .then((result) => {
        if (!cancelled) setToken(result.accessToken);
      })
      .catch(() => {
        if (!cancelled) setToken('');
      });

    return () => {
      cancelled = true;
    };
  }, [loading, tenantUuid, organizationUuid, memberUuid]);

  if (!token) return null;

  return <NotificationIcon token={token} />;
};

export default OpenPlatformNotificationIcon;
